//C:\ViYash\XPRSuvey\XPRSuvey-App\src\Components\Survey\Pages\AddUser.jsx

import React, { useEffect, useState } from "react";
import { Link, useNavigate,  useOutletContext } from "react-router-dom";
import { motion } from "framer-motion";
import {
    User,
    Mail,
    Phone,
    Building2,
    Shield,
    UserRound,
    X,
    UserPlus,
    ChevronRight,
    ChevronDown,
    ShieldCheck,
} from "lucide-react";
import { GetRoles, CompanyDropdown } from "../../../Services/MasterDataService";
import { AddUserAPI } from "../../../Services/SurveyService";



const AddUser = () => {
    const [roles, setRoles] = useState([]);
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        mobile: "",
        companyId: "",
        role: "",
        
    });
    const [companyList, setCompnayList] = useState([])
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();
    const { refreshUsers } = useOutletContext() ?? {};

    const handleClose = () => {
        navigate("/dashboard/users");
    };

    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await GetRoles();
                if (response?.data?.status === "success") {
                    const roleData = response?.data?.roleList || [];
                    const filteredRoles = roleData.filter((r) => r.roleName !== "Company User");
                    setRoles(filteredRoles);
                }
                else {
                    CustomToast("error", response?.data?.message || "Failed to fetch roles");
                }
            } catch (error) {
                CustomToast("error", "An error occurred while fetching roles");
            }
        };

        fetchRoles();
    }, []);

    useEffect(() => {
        const fetchCompanyList = async () => {
            try {
                const response = await CompanyDropdown();
                if (response?.data?.status === "success") {
                    const companyData = response?.data?.companyList || [];
                    setCompnayList(companyData);
                } else {
                    CustomToast("error", response?.data?.message || "Failed to fetch company list");
                }
            } catch (error) {
                CustomToast("error", "An error occurred while fetching company list");
            }
        }
        fetchCompanyList();
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitting) {
            return;
        }
        try {
            setSubmitting(true);
            const payload = {
                FullName: formData.fullName.trim(),
                Email: formData.email.trim(),
                MobileNumber: formData.mobile.trim(),
                CompanyID: Number(formData.companyId),
                RoleID: Number(formData.role),
                
            };
            const response = await AddUserAPI(payload);
            if (response?.data?.status === "success") {
                CustomToast("success", response?.data?.message || "User added successfully.");
                refreshUsers?.();
                setTimeout(() => {
                    handleClose();
                }, 1000);
                return;
            }
            CustomToast("fail", response?.data?.message || "Failed to add user.");
        } catch (error) {
            CustomToast("fail", error?.response?.data?.message || "An error occurred while adding the user.");
        }
        finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 z-[100] overflow-hidden">
            <motion.button
                type="button"
                aria-label="Close add user drawer"
                onClick={handleClose}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="absolute inset-0 bg-slate-900/40 backdrop-blur-[2px]"
            />

            <motion.aside
                initial={{ x: "100%" }}
                animate={{ x: 0 }}
                exit={{ x: "100%" }}
                transition={{ type: "tween", duration: 0.28, ease: "easeOut" }}
                className="absolute right-0 top-0 h-full w-full max-w-4xl bg-[#f8f8fb] shadow-2xl"
            >
                <div className="flex h-full flex-col">
                    <div className="border-b border-gray-200 bg-white px-5 py-4 sm:px-6">
                        <div className="flex items-start justify-between gap-4">
                            <div>
                                <h1 className="text-2xl font-bold text-gray-900">Add New User</h1>
                                <div className="mt-1 flex items-center gap-1.5 text-sm">
                                    <Link to="/dashboard/users" className="text-[#7f35b2] hover:underline">
                                        Users
                                    </Link>
                                    <ChevronRight size={14} className="text-gray-400" />
                                    <span className="text-gray-500">Add New User</span>
                                </div>
                            </div>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 text-gray-500 transition hover:border-[#7f35b2] hover:text-[#7f35b2]"
                            >
                                <X size={18} />
                            </button>
                        </div>
                    </div>

                    <div className="flex-1 overflow-y-auto p-4 sm:p-5">
                        <div className="flex items-start gap-4 rounded-2xl border border-gray-100 bg-white p-5 shadow-sm">
                            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#c2a8f033]">
                                <ShieldCheck size={20} className="text-[#7f35b2]" />
                            </div>
                            <div>
                                <h3 className="text-sm font-semibold text-[#7f35b2]">Manage users with ease</h3>
                                <p className="mt-1 text-sm text-gray-500">
                                    Add new team members and assign appropriate roles to control access and permissions across the platform.
                                </p>
                            </div>
                        </div>

                        <div className="mt-4 rounded-2xl border border-gray-100 bg-white p-5 shadow-md sm:p-6">
                            <div className="mx-auto max-w-2xl">
                                <form onSubmit={handleSubmit} className="flex flex-col gap-5">
                                    <div>
                                        <h2 className="inline-block border-b-2 border-[#7f35b2] pb-1 text-lg font-semibold text-[#7f35b2]">
                                            User Information
                                        </h2>
                                        <p className="mt-2 text-sm text-gray-500">Enter the details of the new user.</p>
                                    </div>

                                    <div>
                                         <label className="mb-1.5 block text-sm font-medium text-gray-700">
                                            Full Name <span className="text-red-500">*</span>
                                        </label>
                                        <div className="relative">
                                            <User size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                            <input
                                                type="text"
                                                name="fullName"
                                                value={formData.fullName}
                                                onChange={handleChange}
                                                placeholder="Enter full name"
                                                required
                                                className="w-full rounded-lg border border-gray-200 py-2.5 pl-10 pr-3 text-sm text-gray-900 outline-none placeholder:text-gray-400 focus:border-[#7f35b2] focus:ring-1 focus:ring-[#7f35b2]"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                         <label className="mb-1.5 block text-sm font-medium text-gray-700">
                                            Email Address <span className="text-red-500">*</span>
                                        </label>
                                        <div className="relative">
                                            <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                placeholder="Enter email address"
                                                required
                                                className="w-full rounded-lg border border-gray-200 py-2.5 pl-10 pr-3 text-sm text-gray-900 outline-none placeholder:text-gray-400 focus:border-[#7f35b2] focus:ring-1 focus:ring-[#7f35b2]"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                       <label className="mb-1.5 block text-sm font-medium text-gray-700">
                                            Mobile Number <span className="text-red-500">*</span>
                                        </label>
                                        <div className="relative">
                                            <Phone size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                            <input
                                                type="tel"
                                                name="mobile"
                                                value={formData.mobile}
                                                onChange={handleChange}
                                                placeholder="Enter mobile number"
                                                required
                                                className="w-full rounded-lg border border-gray-200 py-2.5 pl-10 pr-3 text-sm text-gray-900 outline-none placeholder:text-gray-400 focus:border-[#7f35b2] focus:ring-1 focus:ring-[#7f35b2]"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label className="mb-1.5 block text-sm font-medium text-gray-700">
                                            Company <span className="text-red-500">*</span>
                                        </label>
                                        <div className="relative">
                                            <Building2 size={16} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                            <select
                                                name="companyId"
                                                value={formData.companyId}
                                                onChange={handleChange}
                                                required
                                                className="w-full appearance-none rounded-lg border border-gray-200 py-2.5 pl-10 pr-8 text-sm text-gray-900 outline-none focus:border-[#7f35b2] focus:ring-1 focus:ring-[#7f35b2]"
                                            >
                                                <option value="">Select company</option>
                                                {companyList.map((company) => (
                                                    <option key={company.companyID} value={company.companyID}>
                                                        {company.companyName}
                                                    </option>
                                                ))}
                                            </select>
                                            <ChevronDown size={14} className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                                        <div>
                                            <label className="mb-1.5 block text-sm font-medium text-gray-700">
                                                    Role <span className="text-red-500">*</span>
                                                </label>
                                            <div className="relative">
                                                <Shield size={16} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                                <select
                                                    name="role"
                                                    value={formData.role}
                                                    onChange={handleChange}
                                                    required
                                                    className="w-full appearance-none rounded-lg border border-gray-200 py-2.5 pl-10 pr-8 text-sm text-gray-900 outline-none focus:border-[#7f35b2] focus:ring-1 focus:ring-[#7f35b2]"
                                                >
                                                    <option value="">Select role</option>
                                                    {roles.map((role) => (
                                                        <option key={role.roleID} value={role.roleID}>
                                                            {role.roleName}
                                                        </option>
                                                    ))}
                                                </select>
                                                <ChevronDown size={14} className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <div className="mt-2 flex flex-wrap items-center gap-3">
                                        <button
                                            type="button"
                                            onClick={handleClose}
                                            className="flex items-center gap-2 rounded-lg border border-gray-200 px-5 py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-50"
                                        >
                                            <X size={16} />
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            disabled={submitting}
                                            className="flex items-center gap-2 rounded-lg bg-[#7f35b2] px-5 py-2.5 text-sm font-medium text-white hover:bg-[#3bb290] disabled:cursor-not-allowed disabled:opacity-60"
                                        >
                                            <UserPlus size={16} />
                                            {submitting ? "Adding..." : "Add User"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </motion.aside>
        </div>
    );
};

export default AddUser;
